import { render, staticRenderFns } from "./MatriculasEjaCard.vue?vue&type=template&id=09cb3911&scoped=true"
import script from "./MatriculasEjaCard.vue?vue&type=script&lang=js"
export * from "./MatriculasEjaCard.vue?vue&type=script&lang=js"
import style0 from "./MatriculasEjaCard.vue?vue&type=style&index=0&id=09cb3911&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cb3911",
  null
  
)

export default component.exports